<script lang="ts" setup>
const emit = defineEmits(['openFiltersDialog'])

type Props = {
  selectedFiltersCount: number
}

defineProps<Props>()

const openFiltersDialog = () => emit('openFiltersDialog')
</script>

<template>
  <div class="filter--widget">
    <the-badge
      color="var(--ui-white)"
      background-color="var(--ui-primary)"
      :content="selectedFiltersCount"
      :offset-x="10"
      :offset-y="10"
    >
      <the-button
        width="48"
        height="48"
        background-color="var(--ui-green)"
        icon="filter"
        icon-color="var(--ui-white)"
        size="sm"
        radius="lg"
        @click="openFiltersDialog"
      />
    </the-badge>
  </div>
</template>

<style lang="scss" scoped>
.filter--widget {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 8;
  padding: 25px;
}
</style>
